export default {
  init() {
    const setInactive = (idx) => {
      const source = $('#disciplines-accordion .et_pb_image_' + idx + ' img').attr('src');
      if (source.indexOf('_hover') > 0) {
        const inactive = source.split('_hover')[0] + '_regular.png';
        $('#disciplines-accordion .et_pb_image_' + idx + ' img').attr('src', inactive);
      }
    }
    const toggleClass = (idx) => {
      for (let i = 0; i < 3; i++) {
        if (i == idx) {
          const source = $('#disciplines-accordion .et_pb_image_' + idx + ' img').attr('src');
          if (source.indexOf('_hover') < 0) {
            const split = $('#disciplines-accordion .et_pb_image_' + idx + ' img').attr('src').split('_regular')[0];
            const active = split + '_hover.png';
            $('#disciplines-accordion .et_pb_image_' + idx + ' img').attr('src', active);
          }
        } else {
          setInactive(i);
        }
      }
    }
    $( document ).ready(function() {
      // Images
      $('#disciplines-accordion .et_pb_image_0').on('click', function() {
        $('.et_pb_accordion_item_0 .et_pb_toggle_title').click();
      });
      $('#disciplines-accordion .et_pb_image_1').on('click', function() {
        $('.et_pb_accordion_item_1 .et_pb_toggle_title').click();
      });
      $('#disciplines-accordion .et_pb_image_2').on('click', function() {
        $('.et_pb_accordion_item_2 .et_pb_toggle_title').click();
      });
      // Titles
      $('#disciplines-accordion .et_pb_accordion_item_0 .et_pb_toggle_title').on('click', function() {
        toggleClass(0);
      });
      $('#disciplines-accordion .et_pb_accordion_item_1 .et_pb_toggle_title').on('click', function() {
        toggleClass(1);
      });
      $('#disciplines-accordion .et_pb_accordion_item_2 .et_pb_toggle_title').on('click', function() {
        toggleClass(2);
      });
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
